import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import logoPng from './assets/logo.png';

// Set favicon to the company logo at runtime
(() => {
	try {
		const existing = document.querySelector("link[rel='icon']");
		const link = existing || document.createElement('link');
		link.setAttribute('rel', 'icon');
		link.setAttribute('type', 'image/png');
		link.setAttribute('href', logoPng);
		if (!existing) {
			document.head.appendChild(link);
		}
	} catch (e) {
		// no-op if document is not available (e.g., in tests)
	}
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);